(function () {
  'use strict';
  let guideInstance = 0;
  function mount(root) {
    if (root.dataset.enhanced) return;
    const form = root.querySelector('[data-guide-controls]');
    const search = root.querySelector('[data-guide-search]');
    const filter = root.querySelector('[data-guide-filter]');
    const status = root.querySelector('[data-guide-status]');
    const empty = root.querySelector('[data-guide-empty]');
    const navigation = root.querySelector('[data-guide-pagination]');
    const previous = root.querySelector('[data-guide-prev]');
    const next = root.querySelector('[data-guide-next]');
    const pageLabel = root.querySelector('[data-guide-page]');
    const tbody = root.querySelector('tbody');
    const rows = Array.from(root.querySelectorAll('[data-guide-row]'));
    const sortButtons = Array.from(root.querySelectorAll('[data-guide-sort]'));
    const pageSize = Number(root.dataset.pageSize);
    if (!Number.isInteger(pageSize) || pageSize < 1) return;
    const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
    const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
    const entries = rows.map((row, index) => ({ row, index, text: normalize(row.textContent), note: row.dataset.filter || '', cells: Array.from(row.cells, cell => cell.textContent) }));
    // Cache full source text above before adding any UI labels. Never shorten catalog text.
    const instance = ++guideInstance;
    const expandableColumns = root.dataset.guideKind === 'essential_oil' ? [2, 3] : root.dataset.guideKind === 'fragrance' ? [1] : [];
    const cells = [];
    let expanded = null;
    function setExpanded(cell, open) {
      cell.text.toggleAttribute('data-collapsed', !open);
      cell.button.setAttribute('aria-expanded', String(open));
      cell.button.textContent = open ? 'View less' : 'View more';
      cell.button.setAttribute('aria-label', `${open ? 'View less' : 'View more'}: ${cell.label}`);
    }
    function collapseExpanded() {
      if (expanded) setExpanded(expanded, false);
      expanded = null;
    }
    entries.forEach(entry => expandableColumns.forEach(column => {
      const td = entry.row.cells[column];
      if (!td || !entry.cells[column].trim()) return;
      const text = document.createElement('span');
      text.id = `pt-guide-cell-${instance}-${entry.index}-${column}`;
      text.setAttribute('data-guide-cell-text', '');
      while (td.firstChild) text.append(td.firstChild);
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'pt-guide-cell-toggle'; button.hidden = true;
      button.setAttribute('aria-controls', text.id);
      const cell = { row: entry.row, text, button, label: `${td.dataset.label}, ${entry.cells[0].trim()}` };
      setExpanded(cell, false);
      button.addEventListener('click', () => {
        const opening = expanded !== cell;
        collapseExpanded();
        if (opening) { expanded = cell; setExpanded(cell, true); }
      });
      td.append(text, button); cells.push(cell);
    }));
    function measureCollapsedCells() {
      cells.forEach(cell => {
        if (cell.row.hidden) return;
        // Measure the real clamped content at the current responsive width.
        cell.button.hidden = !(cell.text.scrollHeight > cell.text.clientHeight + 1);
      });
    }
    const values = [...new Set(entries.map(entry => entry.note).filter(Boolean))].sort();
    values.forEach(value => { const option = document.createElement('option'); option.value = value; option.textContent = value; filter.append(option); });
    filter.parentElement.hidden = values.length < 2;
    let page = 1, sortColumn = -1, direction = 0;
    function update(resetPage) {
      collapseExpanded();
      if (resetPage) page = 1;
      const terms = normalize(search.value).trim().split(/\s+/).filter(Boolean);
      const ordered = entries.slice();
      if (direction) ordered.sort((a, b) => direction * collator.compare(a.cells[sortColumn], b.cells[sortColumn]) || a.index - b.index);
      // The full DOM always retains every row. Sorting cannot change the catalog.
      ordered.forEach(entry => tbody.append(entry.row));
      const matching = ordered.filter(entry => terms.every(term => entry.text.includes(term)) && (!filter.value || entry.note === filter.value));
      const pages = Math.max(1, Math.ceil(matching.length / pageSize));
      page = Math.min(page, pages);
      rows.forEach(row => { row.hidden = true; });
      const start = (page - 1) * pageSize;
      matching.slice(start, start + pageSize).forEach(entry => { entry.row.hidden = false; });
      status.textContent = matching.length ? `Showing ${start + 1}–${Math.min(start + pageSize, matching.length)} of ${matching.length} matching entries (${rows.length} total)` : `No matching entries (${rows.length} total)`;
      empty.hidden = matching.length !== 0;
      pageLabel.textContent = `Page ${page} of ${pages}`;
      previous.disabled = page === 1;
      next.disabled = page === pages;
      measureCollapsedCells();
      sortButtons.forEach(button => {
        const active = Number(button.dataset.guideSort) === sortColumn && direction;
        const value = active ? (direction === 1 ? 'ascending' : 'descending') : 'none';
        button.closest('th').setAttribute('aria-sort', value);
        button.setAttribute('aria-label', `Sort by ${button.dataset.sortLabel}; ${value === 'none' ? 'source order' : value}`);
      });
    }
    search.addEventListener('input', () => update(true));
    filter.addEventListener('change', () => update(true));
    form.addEventListener('submit', event => event.preventDefault());
    root.querySelector('[data-guide-reset]').addEventListener('click', () => { search.value = ''; filter.value = ''; update(true); search.focus(); });
    previous.addEventListener('click', () => { page--; update(false); });
    next.addEventListener('click', () => { page++; update(false); });
    sortButtons.forEach(button => button.addEventListener('click', () => {
      const column = Number(button.dataset.guideSort);
      direction = column !== sortColumn ? 1 : direction === 1 ? -1 : direction === -1 ? 0 : 1;
      sortColumn = column; update(true);
    }));
    root.dataset.enhanced = 'true'; form.hidden = false; navigation.hidden = false;
    update(true);
    // Font loading and responsive changes can alter where a cell overflows.
    let previousWidth = root.getBoundingClientRect().width;
    if ('ResizeObserver' in window) new ResizeObserver(() => {
      const width = root.getBoundingClientRect().width;
      if (width !== previousWidth) { previousWidth = width; collapseExpanded(); measureCollapsedCells(); }
    }).observe(root);
    if (document.fonts) document.fonts.ready.then(() => { collapseExpanded(); measureCollapsedCells(); });
  }
  document.querySelectorAll('[data-pt-guide]').forEach(mount);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-pt-guide]').forEach(mount));
})();
